<template>
  <CDropdown
    placement="auto"
    v-model:visible="visible"
    autoClose="outside"
    v-click-outside="hideDropdown"
    :disabled="disabledSelect"
    v-bind="$attrs"
    :class="[
      bodyClass,
      disabled ? '!tw-opacity-50' : 'tw-cursor-pointer',
      !!errorMessage ? 'tw-border-red-200' : 'tw-border-static-inputBorder',
    ]"
    class="!tw-flex tw-relative tw-w-full tw-h-[40px] tw-border tw-justify-between tw-items-center tw-bg-white !tw-rounded-lg tw-text-blue-dark-500"
  >
    <!--    <CDropdownToggle color="secondary" :caret="false" :custom="true" :disabled="disabled">-->
    <div class="tw-w-full tw-h-full" @click.stop.prevent="openDropdown">
      <div
        class="tw-flex tw-items-center tw-justify-between tw-w-full tw-h-full tw-overflow-hidden"
        :class="!disabledSelect && 'tw-group'"
      >
        <div
          class="tw-flex tw-gap-2 tw-justify-start tw-items-center tw-w-[calc(100%-35px)] tw-select-none tw-pr-2"
        >
          <base-icon v-if="icon" :icon="icon" class="tw-align-middle" />

          <div
            class="tw-flex"
            :class="{ 'tw-hidden': !displayCountSelected }"
            :style="'width: calc(100% - ' + (icon ? '42px' : '0px') + ')'"
          >
            <template v-if="multiple && selectedValue.length">
              <base-animated-text
                :text="
                  Object.values(options).find(
                    (x) => selectedValue.indexOf(reduce(x)) >= 0,
                  )?.label || title
                "
                max-length="full"
              />
              <p
                class="tw-mb-0 tw-text-blue-dark-300"
                v-if="selectedValue.length > 1 && displayCountSelected"
              >
                {{ ' و ' + (selectedValue.length - 1) + ' مورد دیگر' }}
              </p>
            </template>
            <base-animated-text
              v-else-if="!visible"
              :text="
                Object.values(options).find((x) => reduce(x) == selectedValue)
                  ?.label || title
              "
              max-length="full"
            />
          </div>
          <input-ayandeh
            v-if="search_able && visible"
            ref="inputSearchEl"
            class="tw-text-blue-dark-400 tw-bg-transparent"
            @focus="displayCountSelected = false"
            @blur="displayCountSelected = true"
            :transparent="true"
            v-model:value="search_value"
            @stopTyping="doSearch($event)"
          />
        </div>
        <div class="tw-p-2 tw-z-50" v-if="loading">
          <loading-spinner
            size="sm"
            class="tw-my-auto tw-text-blue-dark-100"
            :show="true"
          />
        </div>
        <div
          v-else
          class="tw-overflow-hidden tw-flex tw-justify-end tw-items-center tw-px-1.5 tw-my-auto tw-relative tw-w-14 tw-h-6 max-md:tw-w-14"
        >
          <base-icon
            v-if="
              (multiple && selectedValue.length) || (!multiple && selectedValue)
            "
            @click="deleteValue"
            icon="close"
            class="tw-text-blue-dark-200 tw-p-1 md:tw-absolute tw-top-[-150%] tw-transition-all tw-duration-200"
            :class="[
              ((multiple && selectedValue.length) ||
                (!multiple && selectedValue)) &&
                'group-hover:tw-top-[-1px] hover:tw-text-red-200',
            ]"
            size="20"
          />
          <base-icon
            icon="arrow-down"
            :class="[
              ((multiple && selectedValue.length) ||
                (!multiple && selectedValue)) &&
                'md:tw-absolute tw-top-0 group-hover:tw-top-full',
              visible && 'tw-rotate-180',
            ]"
            class="tw-transition-all tw-duration-200"
          />
        </div>
      </div>
      <label
        class="tw-absolute tw-text-tiny tw-top-[-12px] tw-px-1"
        :class="[
          props.icon ? 'tw-right-[29px]' : 'tw-right-[10px]',
          floatTitleBg ? floatTitleBg : 'tw-bg-white',
        ]"
        v-text="title"
        v-if="
          (floatTitle && !multiple && !!selectedValue) ||
          (floatTitle && multiple && selectedValue.length) ||
          visible
        "
      >
      </label>
      <!--    </CDropdownToggle>-->
    </div>
    <CDropdownMenu
      ref="dropdownMenu"
      class="menu tw-w-full !tw-min-w-full tw-max-h-[60vh] tw-self-start !tw-mt-11 !tw-pt-0 tw-overflow-y-auto"
    >
      <div
        class="tw-py-8 tw-text-center tw-px-4 tw-text-blue-dark-200"
        v-if="showAlert"
        v-text="showAlert"
      ></div>
      <template v-else>
        <div
          class="tw-py-8 tw-text-center tw-px-4 tw-text-blue-dark-200"
          v-if="!loading && !options.length"
        >
          <div v-if="!!search_value">
            هیج موردی مشابه با
            <span class="tw-text-blue-dark-500 tw-font-bold"
              >"{{ search_value }}"</span
            >
            یافت نشد.
          </div>
          <span v-else>هیچ موردی وجود ندارد</span>
        </div>
        <template v-else>
          <!--       همه     -->
          <CDropdownItem
            v-if="multiple"
            class="!tw-py-2"
            @click="toggleSelectAll"
          >
            <div>
              <base-icon
                v-if="selected_all"
                icon="check-box-bold"
                class="tw-text-blue-dark-400 tw-ml-2 tw-inline-block tw-align-middle"
              />
              <base-icon
                v-else
                icon="check-box-outline"
                class="tw-text-blue-dark-400 tw-ml-2 tw-inline-block tw-align-middle"
              />
              همه
            </div>
          </CDropdownItem>
          <CDropdownItem
            v-for="opt in getItems"
            :class="[selectedValue === reduce(opt) && '!tw-bg-blue-dark-50']"
            :disabled="
              opt?.disabled ||
              selectedValue === reduce(opt) ||
              Object.values(disabledOptions).some((x) => x === reduce(opt))
            "
            :key="reduce(opt)"
            @click="selectOption(reduce(opt))"
          >
            <div
              class="tw-flex align-items-center"
              :class="[opt.label2 && 'tw-justify-between']"
            >
              <div>
                <base-icon
                  v-if="multiple && selectedValue.indexOf(opt.value) >= 0"
                  icon="check-box-bold"
                  class="tw-text-blue-dark-400 tw-ml-2 tw-block tw-my-auto"
                />
                <base-icon
                  v-else-if="multiple"
                  icon="check-box-outline"
                  class="tw-text-blue-dark-400 tw-ml-2 tw-block tw-my-auto"
                />
                <span v-if="opt.label2">{{ opt.label2 }}</span>
              </div>
              <base-animated-text max-length="full" class="!tw-py-2">{{
                opt.label || '-'
              }}</base-animated-text>
            </div>
          </CDropdownItem>
          <div v-if="loading" v-for="i in 5" class="tw-py-1 tw-px-3 tw-my-3">
            <shine-loading width="100" size="lg" :body_height="35" />
          </div>
        </template>
      </template>
    </CDropdownMenu>
  </CDropdown>
  <p
    v-if="!!errorMessage"
    class="tw-text-red-300 tw-text-tiny tw-mb-1"
    v-text="errorMessage"
  ></p>
</template>

<script setup>
import { computed, defineProps, ref, watch, nextTick, onMounted } from 'vue'
import BaseIcon from '@/components/base/BaseIcon.vue'
import BaseAnimatedText from '@/components/base/BaseAnimatedText.vue'
import LoadingSpinner from '@/components/loading/LoadingSpinner.vue'
import {
  arabicToPersian,
  persianToArabic,
} from '@/services/more/ArabicConverter'
import InputAyandeh from '@/components/inputs/InputAyandeh.vue'
import { useInfiniteScroll } from '@vueuse/core'
import ShineLoading from '@/components/loading/ShineLoading.vue'
import Plate from '@/components/partial/Plate.vue'
import { useStore } from 'vuex'

const visible = ref(false)
const search_value = ref('')

const uuid = Math.random().toString(36).slice(2)
const store = useStore()

const emit = defineEmits([
  'update:modelValue',
  'change',
  'loadMore',
  'selectedAll',
])
const dropdownMenu = ref(null)
const inputSearchEl = ref(null)
const displayCountSelected = ref(true)
const props = defineProps({
  options: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: 'انتخاب',
  },
  placeholder: {
    type: String,
    default: null,
  },
  icon: {
    type: String,
    default: null,
  },
  modelValue: {
    type: [String, Number, Array, null],
    default: null,
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  floatTitle: {
    type: Boolean,
    default: false,
  },
  floatTitleBg: {
    type: String,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  showAlert: {
    type: String,
    default: null,
  },
  errorMessage: {
    type: String,
    default: null,
  },
  search_able: {
    type: Boolean,
    default: false,
  },
  search_in_front: {
    type: Boolean,
    default: false,
  },
  canLoadMore: { type: Boolean, default: false },
  disabledOptions: {
    type: Array,
    default: () => [],
  },
  reduce: {
    type: Function,
    default: (opt) => opt.value,
  },
  bodyClass: {
    type: String,
    default: '',
  },
  allSelectedDefault: {
    type: Boolean,
    default: false,
  },
})

const selectedValue = ref(props.multiple ? [] : null)

onMounted(() => {
  if (props.modelValue) {
    selectedValue.value = props.modelValue
  }
})

watch(
  () => visible.value,
  (value) => {
    if (value && props.search_able) {
      nextTick(() => {
        inputSearchEl.value.$refs.input?.focus()
      })
    }
  },
)

function hideDropdown() {
  store.state.OpenedSelectBox = null
}
function openDropdown() {
  if (disabledSelect.value) return
  store.state.OpenedSelectBox = uuid
}

function toggleSelectAll() {
  if (props.multiple) {
    if (selectedValue.value.length === props.options.length) {
      unSelectAll()
    } else {
      selectAll()
    }
  }
}

function unSelectAll() {
  selectedValue.value = []
  emit('selectedAll', false)
}
function selectAll() {
  selectedValue.value = props.options.map((opt) => props.reduce(opt))
  emit('selectedAll', true)
}
const selected_all = computed(() => {
  return (
    props.multiple &&
    props.options.length &&
    selectedValue.value.length === props.options.length
  )
})

function deleteValue() {
  if (props.multiple) {
    selectedValue.value = []
  } else {
    selectedValue.value = null
  }
}

function selectOption(value) {
  if (disabledSelect.value) return

  if (props.multiple) {
    selectedValue.value

    const index = selectedValue.value.indexOf(value)
    if (index > -1) {
      selectedValue.value.splice(index, 1)
    } else {
      selectedValue.value.push(value)
    }
  } else {
    search_value.value = ''
    selectedValue.value = value
  }

  if (!props.multiple) hideDropdown()
}

watch(
  () => selectedValue.value,
  () => {
    emit('update:modelValue', selectedValue.value)
    emit('change', selectedValue.value)
  },
  { deep: true },
)

watch(
  () => props.modelValue,
  (newVal) => {
    selectedValue.value = newVal
  },
  { deep: true },
)

const getItems = computed(() => {
  if (!!search_value.value && props.options.length && props.search_in_front) {
    console.log('search_value: ' + search_value)
    const persianText = arabicToPersian(search_value.value)
    const arabicText = persianToArabic(search_value.value)
    const persinanItems = props.options.filter((obj) =>
      JSON.stringify(obj).toLowerCase().includes(persianText.toLowerCase()),
    )
    const arabicItems = props.options.filter((obj) =>
      JSON.stringify(obj).toLowerCase().includes(arabicText.toLowerCase()),
    )

    return [...persinanItems, ...arabicItems].filter(
      (v, i, a) => a.findIndex((t) => t.value === v.value) === i,
    )
  }
  return props.options
})

const disabledSelect = computed(() => {
  return props.loading || props.disabled
})

function doSearch() {
  emit('loadMore', {
    page: 1,
    search: search_value.value,
  })
}

const { stop } = useInfiniteScroll(dropdownMenu, () => {
  if (props.canLoadMore && !props.loading) {
    emit('loadMore', {
      search: search_value.value,
    })
  }
})

watch(
  () => props.options,
  (newVal, oldVal = []) => {
    if (
      props.allSelectedDefault &&
      props.multiple &&
      newVal.length !== oldVal.length
    ) {
      selectAll()
    }
  },
  { deep: true },
)

const OpenedSelectBox = computed(() => store.state.OpenedSelectBox)
watch(
  () => OpenedSelectBox.value,
  (newVal) => {
    if (newVal === uuid) {
      visible.value = true
    } else {
      visible.value = false
    }
  },
)
</script>

<style scoped>
/* .menu {
  //transform: translate(0, 10px);
  //align-self: start;
  //padding-top: 0;
} */
</style>
